<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Score Report</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="center" class="row-header">
            <h2>Course Selection</h2>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Course</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
            <div style="width: 3.125rem" />
            <div style="width: 30%">
              <div class="input-label">Section</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Semester</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
            <div style="width: 3.125rem" />
            <div style="width: 30%">
              <div class="input-label">Academic year</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Topic</div>
              <select class="input input-select">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center">
            <div class="button button-icon button-green">
              Export Report
              <img src="@/assets/images/admin/Download.svg" class="icon icon-invert" />
            </div>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "scoreReport"
};
</script>
